
let nextToastId = 1;

const timers = new Map();

export default {
  namespaced: true,

  state: () => ({
    items: [],
  }),

  mutations: {
    ADD_TOAST(state, toast) {
      state.items.push(toast);
    },

    REMOVE_TOAST(state, id) {
      state.items = state.items.filter(
        toast => toast.id !== id
      );
    },
  },

  actions: {
    show({ commit, dispatch }, options) {
      const data =
        typeof options === "string"
          ? { message: options }
          : options || {};

      const type = ["success", "error", "warning", "info"].includes(data.type)
        ? data.type
        : "success";

      const duration = Number.isFinite(Number(data.duration))
        ? Math.max(0, Number(data.duration))
        : 3500;

      const toast = {
        id: nextToastId++,
        type,
        title: data.title || (
          type === "success" ? "Succès !" :
          type === "error" ? "Une erreur est survenue" :
          type === "warning" ? "Attention" :
          "Information"
        ),
        message: data.message || "",
        duration,
      };

      commit("ADD_TOAST", toast);

      if (duration > 0) {
        const timer = setTimeout(() => {
          dispatch("remove", toast.id);
        }, duration);

        timers.set(toast.id, timer);
      }

      return toast.id;
    },

    remove({ commit }, id) {
      if (timers.has(id)) {
        clearTimeout(timers.get(id));
        timers.delete(id);
      }

      commit("REMOVE_TOAST", id);
    },
  },
};
